import React from 'react';
import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { ACTIVITY_TYPE } from '../userRequests/ActivityPanel/constants';
import { ActivityMessage } from '../userRequests/ActivityPanel/types';

const IconContainer = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(2),
  flexShrink: 0,
}));

const PrimaryIconContainer = styled(IconContainer)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));

const SecondaryIconContainer = styled(IconContainer)(() => ({
  backgroundColor: '#72BAFD',
  color: '#ffffff',
}));

const DefaultIconContainer = styled(IconContainer)(() => ({
  backgroundColor: '#f8f9fa',
  color: '#495057',
}));

const StyledIcon = styled('svg')(() => ({
  width: 16,
  height: 16,
}));

export const ActivityIcon = ({ type }: { type: ActivityMessage['type'] }) => {
  const normalizedType = type.toUpperCase();

  const getContainer = () => {
    switch (normalizedType) {
      case ACTIVITY_TYPE.STATUS_CHANGED:
      case ACTIVITY_TYPE.REASSIGNED:
        return PrimaryIconContainer;
      case ACTIVITY_TYPE.REQUEST_CREATED:
        return SecondaryIconContainer;
      default:
        return DefaultIconContainer;
    }
  };

  const getIcon = () => {
    switch (normalizedType) {
      case ACTIVITY_TYPE.MESSAGE:
        return <PermIdentityIcon component={StyledIcon} />;
      case ACTIVITY_TYPE.STATUS_CHANGED:
      case ACTIVITY_TYPE.REASSIGNED:
        return <SystemUpdateAltIcon component={StyledIcon} />;
      case ACTIVITY_TYPE.REQUEST_CREATED:
        return <CloudDownloadIcon component={StyledIcon} />;
      default:
        return <PermIdentityIcon component={StyledIcon} />;
    }
  };

  const Container = getContainer();
  const Icon = getIcon();

  return <Container>{Icon}</Container>;
};
